import styled from 'styled-components';
import { flex } from '../../../styles/utilities/flex';

export const ButtonContainer = styled.div`
    ${flex('row')};
    justify-content: flex-end;
    margin-bottom: 10px;
`;
